import SubjectRow from './view'

export default SubjectRow
